<template lang="pug">
  .crud
    modal-customers(:form='form', :is-add='isModalAdd')
    modal-assign-customer(:form='form')
    modal-prospect-reports(:form='form')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=4 vm-sm=4)
          div
            h2 {{ $t('strings.prospecting') }}:
            span {{ $t('strings.description', {attribute: $t('strings.prospectings')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=8 vm-sm=8)
          div
            vm-button(icon="printer-outline" @click="setModalProspectReports") {{ $t('customers.prospect_reports') }}
            vm-button(icon="alert-circle-outline" @click="printProspectInactived") {{ $t('customers.prospect_status') }}
            vm-button(icon="plus" @click="addCustomer") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteCustomersConfirm" :disabled="!enabledDelete")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
      vm-row(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
          vm-tabs(vm-alignment="left")
            vm-tab(:vm-label="$t('strings.prospectings')")
              customer-prospecting(@editCustomer="editCustomer" @checkSelected="checkSelected" @checkFilters="checkFilters" @assignCustomer="assignCustomer")
            vm-tab(:vm-label="$t('strings.lead')")
              customer-lead(@editCustomer="editCustomer" @checkSelected="checkSelected" @checkFilters="checkFilters" @assignCustomer="assignCustomer")
</template>

<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import CustomerProspecting from '@/components/additionals/CustomerProspecting.vue'
import CustomerLead from '@/components/additionals/CustomerLead.vue'
import ModalCustomers from '@/components/modals/ModalCustomers.vue'
import ModalAssignCustomer from '@/components/modals/ModalAssignCustomer.vue'
import ModalProspectReports from '@/components/modals/ModalProspectReports.vue'

import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'Prospecting',
  components: {
    ModalCustomers,
    ModalAssignCustomer,
    ModalProspectReports,
    CustomerProspecting,
    CustomerLead
  },
  data: () => ({
    isModalAdd: true,
    form: {},
    selected: [],
    enabledDelete: false,
    filters: {
      where: {
        tradename: '',
        contact: '',
        email: '',
        rfc: '',
        param: ''
      },
      whereIn: {
        status: [],
        type_prospect: [1]
      },
      whereBetween: {
        priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    filtersClear: {
      where: {
        param: ''
      },
      whereIn: {
        type_prospect: [1]
      }
    }
  }),
  computed: {
    ...mapGetters([
      'customers',
      'customersCatalog',
      'pagination',
      'filterParams'
    ])
  },
  watch: {
    selected (selected) {
      this.enabledDelete = selected.length > 0
    }
  },
  methods: {
    ...mapActions([
      'setModalVisible',
      'setModalAssignVisible',
      'setModalProspectReports',
      'printReport',
      'printProspectInactived',
      'deleteCustomers'
    ]),
    addCustomer () {
      this.isModalAdd = true
      this.form = {
        payment_terms: 'Contado'
      }
      this.setModalVisible(true)
    },
    editCustomer (customer) {
      this.isModalAdd = false
      this.form = { ...customer }
      this.setModalVisible(true)
    },
    assignCustomer (customer, index) {
      this.setModalAssignVisible(true)
      this.form = { ...customer }
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    checkSelected (selected) {
      this.selected = selected
    },
    checkFilters (filters) {
      this.filters = filters
    },
    async deleteCustomersConfirm () {
      let t = this
      let customersMany = parseDeleteMany(this.selected, 'contact')
      this.auxDeleteCustomer = () => {
        t.deleteCustomers(customersMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.customer'), attribute: customersMany.values }),
        accept: this.auxDeleteCustomer
      })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  float: left;
  position: relative;
}
.filter2 {
  display: none;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
